import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import ContentList from './content-list';
import ScrollView from '@/ui/scroll-view';
import planQuestionStore from './store';
import { Skeleton } from 'antd';
import EE from '@/common/event';
import { HelpOther } from '@/common/helper';
import AddCartTips from './add-cart-tips';
import CountdownBtn from './countdown-btn';

const PlanQuestion = observer(props => {
  const {
    className = '',
    countdownClassName = '',
    event,
    planData,
    planStepId,
    planed = false,
    requestPlanParams,
    hideTitle = false,
    scene = 'right',
  } = props;
  const planRef = useRef(null);
  const [disable, setDisable] = useState(planed);
  const [requested, setRequested] = useState(false);
  const { actions, content } = planQuestionStore.planDataMap[planStepId] || {};
  const addCartData = content?.find(item => item.type == 'goods_info');
  const showCartTips = disable && addCartData;
  const checkedCart = addCartData?.items
    ? addCartData.items.find(item => item.check)
    : false;
  const isLeftScene = scene == 'left';

  useEffect(() => {
    setDisable(planed);
  }, [planed]);

  useLayoutEffect(() => {
    if (scene == 'left' && planData && !disable && planRef.current) {
      setTimeout(() => {
        try {
          planRef.current
            .closest('.message-item-section')
            .scrollIntoView({ behavior: 'smooth' });
        } catch (error) {}
      }, 400);
    }
  }, [planData, scene, disable, planRef]);

  useEffect(() => {
    if (planData) {
      planQuestionStore.setPlanDataMap(planStepId, planData);
    }
    setDisable(planed);
    setRequested(false);
  }, [planData]);
  
  return (
    <div
      ref={planRef}
      className={[
        'mcp-tools-plan relative cursor-default',
        isLeftScene ? '' : 'pr-4px',
        className,
      ]}
      data-id={planStepId}
      onMouseEnter={evt => {
        if(disable || requested) return;
        EE.emit('confirm_countdown_pause', true);
      }}
      onMouseLeave={evt => {
        if(disable || requested) return;
        EE.emit('confirm_countdown_pause', false);
      }}
    >
      {hideTitle || !planData.title ? null : (
        <div
          className={[
            'flex items-center h-20px mb-18px',
            isLeftScene ? '' : 'pl-24px pr-20px',
          ]}
        >
          <SVGPureIcon name="plan_edit" className="size-18px" />
          <span className="text-14px text-black font-bold ml-8px">
            {planData.title}
          </span>
        </div>
      )}
      {(!planData || !planData.content?.length) && !disable ? (
        <Skeleton className="px-24px" active />
      ) : (
        <>
          <ScrollView
            className={[
              isLeftScene ? '' : 'max-h-[calc(100vh-400px)] pl-24px pr-20px',
            ]}
          >
            <ContentList
              event={event}
              disable={disable}
              requested={requested}
              planStepId={planStepId}
              list={content || []}
            />
          </ScrollView>
          <div
            className={[
              'flex pt-12px mcp-mobile-hidden',
              isLeftScene ? '' : 'pl-24px pr-20px',
              showCartTips ? 'hidden' : '',
            ]}
          >
            {(actions || []).map((item, index) => {
              //只有一个按钮时  用确认按钮
              if (index == 0 && actions.length > 1) {
                return (
                  <div
                    key={index}
                    onClick={evt => {
                      if (event?.status == 'running') {
                        evt.stopPropagation();
                      }
                      if (disable || requested) return;
                      if (!item.committable) {
                        HelpOther.toast(item.tips, 'info');
                        return;
                      }
                      setRequested(true);
                      planQuestionStore
                        .handleAction(planStepId, 0, requestPlanParams)
                        .then(res => {
                          if (res.code == 0) {
                            EE.emit('confirm_countdown_reload');
                          }
                        });
                    }}
                    className={[
                      'flex-1 h-36px rounded-8px vh-center text-14px font-bold text-black border-1px border-black border-opacity-16 mr-12px',
                      disable || requested
                        ? 'opacity-30'
                        : 'hover:bg-[rgba(0,0,0,0.03)] cursor-pointer',
                    ]}
                  >
                    {item.action_cn}
                  </div>
                );
              } else {
                return (
                  <div
                    key={index}
                    onClick={evt => {
                      if (event?.status == 'running') {
                        evt.stopPropagation();
                      }
                      if (disable || requested) return;
                      if (!item.committable) {
                        HelpOther.toast(item.tips, 'info');
                        return;
                      }
                      if (addCartData) {
                        if (!checkedCart) {
                          HelpOther.toast('请选择加入购物车的商品', 'info');
                          return;
                        }
                      }
                      setRequested(true);
                      planQuestionStore
                        .handleAction(planStepId, 1, requestPlanParams)
                        .then(res => {
                          if (res?.code == 0) {
                            EE.emit('confirm_countdown_reload');
                          }
                        });
                    }}
                    className={[
                      'flex-1 h-36px rounded-8px vh-center text-14px font-bold bg-black',
                      disable || requested
                        ? 'bg-opacity-6 text-black text-opacity-50'
                        : 'text-white hover:bg-[#333] cursor-pointer',
                    ]}
                  >
                    {item.action_cn}
                    <CountdownBtn
                      planStepId={planStepId}
                      disable={disable || requested}
                      timeout={
                        planData.edit_timeout > planData.timeout
                          ? planData.timeout
                          : planData.edit_timeout
                      }
                      overrun={evt => {
                        setRequested(true);
                        const actionIndex =
                          actions?.findIndex(item => item.default) || 0;
                        planQuestionStore
                          .handleAction(
                            planStepId,
                            actionIndex,
                            requestPlanParams
                          )
                          .then(res => {
                            // if (res.code == 0) {
                            //   setRequested(true);
                            // }
                          });
                      }}
                    />
                  </div>
                );
              }
            })}
          </div>
        </>
      )}
      {showCartTips ? (
        <div className="pl-24px pr-20px mt-10px">
          <AddCartTips added={checkedCart} />
        </div>
      ) : null}
    </div>
  );
});
export default PlanQuestion;
